import { Typography } from "antd";

import InterventionMenuNav from "@/modules/intervention/intervention-menu-nav";
import { getInterventionSectionAsset } from "@/modules/intervention/intervention-section";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { MODEL_KEY } from "@/modules/model";
import { ModelLink } from "@/modules/model-link";

import "./intervention-section-card-header.style.less";

const { Text } = Typography;

const InterventionSectionCardHeader = () => {
  const { section } = useInterventionSectionContext();
  const asset = getInterventionSectionAsset(section);

  if (!section) return null;

  return (
    <div className="intervention-section-card-header">
      <InterventionMenuNav />
      <div className="intervention-section-card-header-title">
        <Text ellipsis>
          {/* use blank space to keep card header visible */}
          {section?.name ?? " "}
        </Text>
      </div>
      <ModelLink model={MODEL_KEY.ASSET} item={asset} showIcon />
    </div>
  );
};

export default InterventionSectionCardHeader;
